import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { GenotypingController } from 'src/controllers/genotyping.controller'
import { GenotypingDto } from 'src/dto/genotyping.dto'

const genotypingController = new GenotypingController()

export const useGetGenotypingList = () => {
  const { userFarm: farmId } = useAuth()

  return useQuery<GenotypingDto[], Error>({
    queryKey: ['getGenotypingList', farmId],
    queryFn: () => genotypingController.getGenotypingListByFarmId(farmId!),
    enabled: !!farmId
  })
}
